import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import FlowsIndex from './FlowsIndex.vue';

export const flowEditorRoute = {
  path: frontendURL('accounts/:accountId/settings/flows/:flowId/edit'),
  name: 'flows_editor',
  component: () => import('./FlowEditorWrapper.vue'),
  meta: {
    featureFlag: FEATURE_FLAGS.FLOWS,
    permissions: ['administrator'],
  },
};

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/flows'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'flows_index',
          component: FlowsIndex,
          meta: {
            featureFlag: FEATURE_FLAGS.FLOWS,
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
